import request from '@/utils/request'

export const userInfo = (data) => {
  return request({
    url: '/hospital/userInfo',
    method: 'post',
    data,
  })
}
export const siteList = (data) => {
  return request({
    url: '/hospital/site',
    method: 'post',
    data,
  })
}


export const reserve = (data) => {
  return request({
    url: '/hospital/reserve',
    method: 'post',
    data,
  })
}
export const myList = (data) => {
  return request({
    url: '/hospital/myList',
    method: 'post',
    data,
  })
}

export const cancel = (data) => {
  return request({
    url: '/hospital/cancel',
    method: 'post',
    data,
  })
}